var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesTools6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 72,
    viewBox: "0 0 70 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_14951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.44318 16.3038C3.76396 16.3038 4.88637 15.217 4.88637 13.7909C4.88637 12.4323 3.83008 11.2773 2.44318 11.2773C1.12241 11.2773 0 12.3642 0 13.7909C0 15.217 1.05628 16.3038 2.44318 16.3038Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33616 7.87801C7.86458 7.87801 8.26073 7.47073 8.26073 6.9273C8.26073 6.38386 7.86458 5.97656 7.33616 5.97656C6.8083 5.97656 6.41211 6.38386 6.41211 6.9273C6.41211 7.47073 6.8083 7.87801 7.33616 7.87801Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7736 13.3774C66.3682 13.3774 66.7644 12.9021 66.7644 12.3586C66.7644 11.7477 66.3021 11.3398 65.7736 11.3398C65.2452 11.3398 64.7168 11.7477 64.7168 12.2906C64.7168 12.9021 65.1791 13.3774 65.7736 13.3774Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9997 72C54.349 72 70 55.9017 70 36C70 16.0983 54.2829 0 34.9997 0C15.6509 0 0 16.0983 0 36C0 55.9017 15.6509 72 34.9997 72Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7312 15.1654C32.8183 14.3233 33.1073 12.7229 32.2305 11.5245C31.412 10.4065 29.8564 10.1096 28.6912 11.0116C27.6041 11.8537 27.3151 13.4547 28.1918 14.6525C29.0104 15.771 30.6436 16.0076 31.7312 15.1654Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_224_14951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9561 58.3599L15.1852 68.0355C14.6118 68.1664 14.0964 67.8776 13.9009 67.2778L0.446354 19.1256C0.318665 18.5358 0.599689 18.0053 1.18284 17.804L33.9628 8.05858C34.5363 7.92712 35.0522 8.21644 35.2471 8.81621L48.7701 56.9784C48.8294 57.5582 48.5387 58.1586 47.9561 58.3599Z",
    fill: "url(#paint0_linear_224_14951)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.5373 33.0159L7.86551 33.7713L6.07617 27.5851L8.68977 26.75L10.5373 33.0159Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.079 31.9564L11.3297 32.7722L8.66992 23.3178L11.3417 22.5625L14.079 31.9564Z",
    fill: "#7D63EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1945 29.7004L18.5815 30.5355L14.9355 18.1532L17.6164 17.3281L21.1945 29.7004Z",
    fill: "#21C4C1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.5261 28.6902L21.913 29.5253L20.916 26.1673L23.6653 25.3516L24.5261 28.6902Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7823 29.4605L9.36298 37.5558C9.13952 37.6667 8.81857 37.4771 8.7211 37.1772C8.61336 36.9478 8.79748 36.6174 9.02094 36.5064L36.4403 28.4106C36.6638 28.3003 36.9847 28.4899 37.0827 28.7898C37.1802 29.0896 37.0736 29.3596 36.7823 29.4605Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5072 32.2103L10.0879 40.306C9.86441 40.4164 9.54347 40.2268 9.44542 39.9269C9.33826 39.6975 9.5224 39.3671 9.74585 39.2561L37.1652 31.1609C37.3887 31.05 37.7096 31.2396 37.8071 31.5395C37.9826 31.7789 37.7888 32.1797 37.5072 32.2103Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3249 34.9015L10.8959 43.0678C10.673 43.1781 10.3515 42.9885 10.254 42.6886C10.1469 42.4592 10.331 42.1288 10.5544 42.0179L37.9732 33.9226C38.1966 33.8117 38.5182 34.0013 38.6156 34.3012C38.7131 34.6011 38.6071 34.871 38.3249 34.9015Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0529 42.6792L11.7728 45.7597C11.5494 45.8706 11.2285 45.6811 11.131 45.3812C11.0238 45.1511 11.2079 44.8207 11.4308 44.7104L21.7012 41.6998C21.9246 41.5894 22.2456 41.7784 22.3436 42.0783C22.3824 42.2984 22.2763 42.5683 22.0529 42.6792Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0354 41.9374L41.7582 44.2561C41.9144 44.6358 41.643 45.0965 41.2058 45.2473L35.347 46.9692L14.0686 53.3126C13.6998 53.4734 13.2517 53.1941 13.1052 52.7445L12.3824 50.4258C12.2262 50.0461 12.4976 49.5854 12.9348 49.4346L34.1356 43.1516L40.0041 41.3594C40.5582 41.3688 40.947 41.5677 41.0354 41.9374Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5099 47.3603L43.2333 49.679C43.3895 50.0587 43.1181 50.5193 42.6809 50.6702L40.728 51.2441L15.6116 58.7448C15.2428 58.9056 14.7947 58.6269 14.6482 58.1768L13.9254 55.8581C13.7692 55.4784 14.0405 55.0177 14.4778 54.8668L39.6523 47.4459L41.5956 46.9424C42.0425 46.7212 42.4318 46.9207 42.5099 47.3603Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.073 52.7296L44.7964 55.0483C44.9526 55.428 44.6812 55.8887 44.244 56.0395L34.1874 59.0097L17.1844 64.0444C16.815 64.2046 16.3675 63.9258 16.221 63.4763L15.566 61.167C15.4098 60.7873 15.6812 60.3266 16.1184 60.1758L33.5587 54.9908L43.178 52.1709C43.5469 52.0101 43.9943 52.2895 44.073 52.7296Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0439 60.2318L33.4842 55.0469L34.191 59.0059L17.1874 64.04C16.8186 64.2008 16.3711 63.9214 16.224 63.4719L15.5012 61.1532C15.4128 60.7835 15.6842 60.3228 16.0439 60.2318Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1719 52.8155L12.4486 50.4968C12.2929 50.1171 12.5643 49.6564 13.0015 49.5056L34.2018 43.2227L35.2774 47.0208L14.0766 53.3038C13.7078 53.4646 13.2506 53.2551 13.1719 52.8155Z",
    fill: "#21C4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7298 47.3828L40.7958 51.2508L15.6116 58.7416C15.2428 58.9024 14.7947 58.623 14.6482 58.1735L13.9254 55.8548C13.7692 55.4751 14.0405 55.0144 14.4778 54.8636L39.7298 47.3828Z",
    fill: "#21C4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0672 47.9609L19.1428 51.7591L14.0809 53.2392C13.7115 53.4 13.264 53.1206 13.1175 52.6711L12.3942 50.3524C12.238 49.9727 12.5093 49.512 12.9465 49.3612L18.0672 47.9609Z",
    fill: "#7D63EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4835 54.8668L19.5455 53.3867L20.6212 57.1849L15.5592 58.665C15.1904 58.8258 14.7424 58.5464 14.5959 58.0969L13.873 55.7782C13.9306 55.358 14.1244 54.9578 14.4835 54.8668Z",
    fill: "#7D63EC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_224_14951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5845 60.7614L29.5077 60.9122C28.9542 60.8923 28.5004 60.4369 28.5198 59.867L28.3477 11.8938C28.367 11.324 28.8094 10.8574 29.3629 10.8774L63.4403 10.7266C63.9938 10.7465 64.4475 11.2019 64.4281 11.7712L64.6003 59.745C64.6493 60.3084 64.207 60.7749 63.5845 60.7614Z",
    fill: "url(#paint1_linear_224_14951)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.498 30.7326L32.0691 30.7901C31.7949 30.8153 31.5652 30.5524 31.5407 30.2707C31.5162 29.989 31.7716 29.7525 32.0457 29.7273L60.4683 29.5993C60.742 29.5741 60.9717 29.837 60.9962 30.1187C61.027 30.4708 60.7716 30.7073 60.498 30.7326Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.525 33.4981L32.034 33.6325C31.7598 33.6577 31.5301 33.3948 31.5055 33.1131C31.481 32.8314 31.7364 32.5949 32.0106 32.5697L60.5016 32.4353C60.7752 32.41 61.0055 32.673 61.03 32.9547C61.0603 33.3068 60.7992 33.4729 60.525 33.4981Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4976 36.3444L32.075 36.4723C31.8008 36.4976 31.5711 36.2346 31.5466 35.9529C31.522 35.6713 31.7774 35.4347 32.0516 35.4095L60.5426 35.2751C60.8163 35.2499 61.0465 35.5128 61.0711 35.7945C61.0329 36.1531 60.7775 36.3896 60.4976 36.3444Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6829 17.9162L32.0554 17.9402C31.7813 17.9655 31.5515 17.7026 31.527 17.4209C31.5025 17.1392 31.7579 16.9021 32.0321 16.8774L44.6533 16.7829C44.9269 16.7577 45.1566 17.0206 45.1811 17.3023C45.2056 17.584 44.8881 17.8974 44.6829 17.9162Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6419 20.69L32.0144 20.7141C31.7408 20.7393 31.5111 20.4764 31.486 20.1947C31.4615 19.9124 31.7175 19.6759 31.9911 19.6507L44.6185 19.6266C44.8922 19.602 45.1224 19.8649 45.147 20.1466C45.1772 20.4987 44.9155 20.6648 44.6419 20.69Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5537 23.5534L31.9969 23.5581C31.7227 23.5833 31.4929 23.3204 31.4684 23.0387C31.4439 22.757 31.6993 22.5205 31.9729 22.4952L40.5303 22.49C40.8039 22.4647 41.0342 22.7277 41.0588 23.0099C41.089 23.3621 40.8279 23.5281 40.5537 23.5534Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4856 45.6393L50.8953 45.6686C50.6217 45.6939 50.3914 45.431 50.3669 45.1493C50.3424 44.8676 50.5983 44.6311 50.8719 44.6058L60.4622 44.5759C60.7358 44.5507 60.9661 44.8136 60.9906 45.0959C60.9467 45.3834 60.7655 45.6845 60.4856 45.6393Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5635 45.8785C48.9802 45.9113 49.292 45.5275 49.2555 45.105C49.2869 44.6766 48.914 44.3556 48.503 44.3937C48.0863 44.3608 47.7745 44.7446 47.8116 45.1672C47.8481 45.5897 48.1525 45.9166 48.5635 45.8785Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4792 48.7643L50.8889 48.7936C50.6153 48.8189 50.3855 48.556 50.361 48.2743C50.3365 47.9926 50.5919 47.7561 50.8655 47.7308L60.4558 47.7009C60.73 47.6757 60.9597 47.9386 60.9842 48.2203C60.9403 48.5084 60.7596 48.8095 60.4792 48.7643Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5615 49.0079C48.9788 49.0407 49.29 48.6569 49.2535 48.2344C49.2849 47.806 48.9121 47.485 48.5016 47.5225C48.0844 47.4902 47.7726 47.8735 47.8096 48.2966C47.8461 48.7191 48.2195 49.0396 48.5615 49.0079Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5501 51.9557L50.9597 51.985C50.6856 52.0103 50.4558 51.7474 50.4313 51.4657C50.4068 51.184 50.6622 50.9475 50.9364 50.9222L60.5267 50.8923C60.8003 50.8671 61.0306 51.13 61.0551 51.4117C61.005 51.6294 60.7553 51.9363 60.5501 51.9557Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6338 52.1988C49.0505 52.2316 49.3623 51.8478 49.3258 51.4253C49.3572 50.9969 48.9844 50.6759 48.5734 50.714C48.1567 50.6812 47.8448 51.065 47.8819 51.4875C47.8437 51.8455 48.2171 52.1665 48.6338 52.1988Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9428 44.4452L37.9223 41.0391C34.351 41.2257 31.5841 44.3196 31.5664 48.0838C31.5698 50.497 32.7925 52.6566 34.6264 53.9078L36.223 50.8503C35.409 50.2153 34.9063 49.1965 34.8709 47.9928C34.8544 46.2199 36.2378 44.6729 37.9428 44.4452Z",
    fill: "#7D63EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8242 41.0273L38.8447 44.4335C39.8902 44.5503 40.8416 45.173 41.4065 46.1149L44.1404 44.231C43.0168 42.417 41.1141 41.1723 38.8242 41.0273Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6243 45.043L41.822 46.9338C41.9206 47.2795 42.0198 47.6252 41.9885 48.0542C42.0232 50.0389 40.4403 51.6751 38.4429 51.7168C37.8894 51.6968 37.3974 51.6 36.9687 51.4263L35.3652 54.4134C36.3047 54.8952 37.3621 55.1529 38.4634 55.1229C42.2593 55.1288 45.2941 51.9392 45.2987 48.0342C45.2753 46.9714 45.0462 45.9274 44.6243 45.043Z",
    fill: "#21C4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3228 25.2558L49.5306 25.2787C49.1886 25.3098 48.9526 24.9765 48.9281 24.6948L48.9024 20.4377C48.8716 20.0855 49.196 19.8432 49.4696 19.8179L51.2618 19.7951C51.6044 19.7634 51.8404 20.0967 51.8649 20.3784L51.89 24.6355C51.9208 24.9876 51.6717 25.2946 51.3228 25.2558Z",
    fill: "#7D63EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.881 25.2659L54.0889 25.2888C53.7468 25.3205 53.5108 24.9872 53.4863 24.7055L53.4943 18.4577C53.4641 18.1056 53.7879 17.8626 54.0615 17.8374L55.8537 17.8145C56.1963 17.7834 56.4323 18.1168 56.4568 18.3985L56.4482 24.6462C56.479 24.9983 56.1547 25.2407 55.881 25.2659Z",
    fill: "#21C4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3628 25.2034L58.5707 25.2263C58.2286 25.2574 57.9926 24.9241 57.9681 24.6424L57.9356 16.34C57.9049 15.9879 58.2286 15.7449 58.5028 15.7197L60.2944 15.6974C60.637 15.6657 60.8731 15.9991 60.8976 16.2807L60.9301 24.5831C60.9608 24.9352 60.7111 25.2422 60.3628 25.2034Z",
    fill: "#7D63EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_224_14951",
    x: -19.584,
    y: -0.972656,
    width: 88.3613,
    height: 100.039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_224_14951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_224_14951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_224_14951",
    x: 6.34766,
    y: -0.273438,
    width: 80.2559,
    height: 94.1875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_224_14951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_224_14951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_14951",
    x1: 28.9955,
    y1: 5.80326,
    x2: 19.7701,
    y2: 69.4591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#FEFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_224_14951",
    x1: 44.0653,
    y1: 8.29108,
    x2: 49.0644,
    y2: 62.6758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9965,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_14951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesTools6);
export default __webpack_public_path__ + "static/media/sales-tools-6.3e7dd22f521de7dce461495e391849fc.svg";
export { ForwardRef as ReactComponent };